export default { SET_MARKS: 'SET_MARKS', SET_EXPERT_TIPS: 'SET_EXPERT_TIPS' };
